const STORAGE_KEYS = {
  USERNAME: 'blather_username',
  LOBBY_ID: 'blather_lobby_id',
  PLAYER_ID: 'blather_player_id',
};

export function savePlayerIdentity(username: string, lobbyId: string, playerId: string): void {
  try {
    localStorage.setItem(STORAGE_KEYS.USERNAME, username);
    localStorage.setItem(STORAGE_KEYS.LOBBY_ID, lobbyId);
    localStorage.setItem(STORAGE_KEYS.PLAYER_ID, playerId);
  } catch (error) {
    console.error('Failed to save player identity to localStorage:', error);
  }
}

export function getPlayerIdentity(): {
  username: string | null;
  lobbyId: string | null;
  playerId: string | null;
} {
  try {
    return {
      username: localStorage.getItem(STORAGE_KEYS.USERNAME),
      lobbyId: localStorage.getItem(STORAGE_KEYS.LOBBY_ID),
      playerId: localStorage.getItem(STORAGE_KEYS.PLAYER_ID),
    };
  } catch (error) {
    console.error('Failed to get player identity from localStorage:', error);
    return { username: null, lobbyId: null, playerId: null };
  }
}

export function clearPlayerIdentity(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.USERNAME);
    localStorage.removeItem(STORAGE_KEYS.LOBBY_ID);
    localStorage.removeItem(STORAGE_KEYS.PLAYER_ID);
  } catch (error) {
    console.error('Failed to clear player identity from localStorage:', error);
  }
}
